import React, { useCallback, useEffect, useState } from "react";

import { FaGraduationCap, FaFileAlt } from "react-icons/fa";
import { BiPlusMedical } from "react-icons/bi";

import {
  Container,
  Notification,
  NotificationIcon,
  NotificationDescription,
  NotificationButton,
  IconContainer,
  DateContainer,
} from "./styles";
import { producaov2 as api } from "../../services/apis";
import { getUserNode } from "../../services/auth_node";

const NotificationsBlock = (props) => {
  const [notifications, setNotifications] = useState([]);
  const [notificationsStatus, setNotificationsStatus] = useState(true);
  const [receivedAll, setReceivedAll] = useState(false);
  const [page, setPage] = useState(0);
  const [notRead, setNotRead] = useState(true);
  const [updateNotification, setUpdateNotification] = useState(false);
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const [newUnreadNotifications, setNewUnreadNotificarions] = useState([]);

  useEffect(() => {
    if (props.active && !receivedAll) {
      api
        .get("/notificacoes/receivedAll", {
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        })
        .catch((err) => console.error("Erro", err));

      setReceivedAll(true);
    }
  }, [props.active, receivedAll]);

  useEffect(() => {
    if (!props.active) {
      setUpdateNotification(!updateNotification);
    }
  }, [props.active]);

  useEffect(() => {
    props.handlerUnreadedNotifications(unreadNotifications);
  }, [unreadNotifications]);

  useEffect(() => {
    api
      .get(`notificacoes?${notRead ? "notread=1" : ""}&page=${page}`, {
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      })
      .then((res) => {
        const { notificacoes } = res.data;

        notificacoes.sort((a, b) => {
          const receivedA = userReceived(a);
          const receivedB = userReceived(b);

          if (receivedA !== receivedB) {
            if (receivedA) {
              return 1;
            }

            return -1;
          }

          return new Date(b.id).getTime() - new Date(a.id).getTime();
        });

        if (notificacoes.length) {
          setNotificationsStatus(false);
        }

        console.log("NOTIFICACOES :: ", notificacoes);

        setNotifications(notificacoes);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [page, notRead, updateNotification]);

  const userReceived = (notification) => {
    try {
      const usersReceived = JSON.parse(
        notification?.statusReceived
      )?.map((id) => Number(id));

      if (!usersReceived) {
        return false;
      }

      return usersReceived.includes(getUserNode().id);
    } catch (err) {
      console.error("Erro", err);
      return false;
    }
  };

  const userReaded = (notification) => {
    try {
      const usersReaded = JSON.parse(notification?.statusReaded).map((id) =>
        Number(id)
      );

      if (!usersReaded) {
        return false;
      }

      return (
        usersReaded.includes(getUserNode().id) ||
        newUnreadNotifications.includes(notification.id)
      );
    } catch (err) {
      return false;
    }
  };

  useEffect(() => {
    const notReadTotal = notifications.reduce((sum, notification) => {
      if (!userReaded(notification) && !userReceived(notification)) {
        return sum + 1;
      }

      return sum;
    }, 0);

    setUnreadNotifications(notReadTotal);
  }, [notifications]);

  const notificationRedirect = useCallback((notification) => {
    const actions = {
      assistir: "/online/assistir/",
      blog: "/blog/artigo/",
      tickets: "/online/tickets/",
      link: "",
    };

    if (actions[notification.action] !== "" && !actions[notification.action]) {
      return "";
    }

    return actions[notification.action] + notification.actionData;
  }, []);

  const setReadedNotification = useCallback(async (notification) => {
    return api
      .put(
        `/notificacoes/${notification.id}?set=read`,
        {},
        {
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        }
      )
      .catch((err) => console.error("Erro", err));
  }, []);

  const handleNotificationClick = useCallback(
    async (notification) => {
      await setReadedNotification(notification);
      const redirectLink = notificationRedirect(notification);

      if (!JSON.parse(notification?.statusReaded).includes(notification.id)) {
        setUnreadNotifications(unreadNotifications);

        setNewUnreadNotificarions([
          ...newUnreadNotifications,
          notification?.id,
        ]);
      }

      if (redirectLink !== "") {
        window.open(redirectLink);
      }
    },
    [setReadedNotification, notificationRedirect]
  );

  const seeOlderNotifications = useCallback(() => {
    if (notRead) {
      setNotRead(false);
      setPage(0);
      return;
    }

    setPage((page) => page + 1);
  }, [notRead]);

  return (
    <Container active={props.active}>
      {notifications.length !== 0 ? (
        notifications?.map((notification) => (
          <span
            onClick={() => handleNotificationClick(notification)}
            key={notification.id}
          >
            <Notification active={!userReceived(notification)}>
              <NotificationIcon>
                {notification.action === "certificate" ? (
                  <FaGraduationCap size={32} />
                ) : notification.action === "blog" ? (
                  <IconContainer>
                    <FaFileAlt size={32} />
                    <span>New!</span>
                  </IconContainer>
                ) : (
                  <img
                    src={`${JSON.parse(notification.icon).value}`}
                    alt="Perfil do aluno"
                  />
                )}
              </NotificationIcon>
              <NotificationDescription>
                <div>{notification.message}</div>
                {notification.action === "blog" && (
                  <DateContainer>
                    {new Date(notification.timestamp).toLocaleDateString(
                      "pt-br",
                      {
                        timeZone: "America/Sao_Paulo",
                      }
                    )}
                  </DateContainer>
                )}
              </NotificationDescription>
            </Notification>
          </span>
        ))
      ) : (
        <Notification>Não há notificações novas</Notification>
      )}
      {notificationsStatus && (
        <NotificationButton
          onClick={seeOlderNotifications}
          aria-label="Ver mais"
        >
          <BiPlusMedical /> <span>Mais Antigas</span>
        </NotificationButton>
      )}
    </Container>
  );
};

export default NotificationsBlock;
